module.exports = __webpack_public_path__ + "img/sticker-1-2.b28c90ff.svg";